import { create } from 'lodash'
import createAsyncThunkMiddleware from '../../utils/helpers/createAsyncThunkMiddleware'
import {
  GET,
  GET_FILE,
  PATCH,
  POST,
  DELETE,
  POST_FILE,
} from '../common/common.service'
import endpointsCenters from './endpoints'

const CenterService = {
  getAll: async ({ centerType, franchiseExit, filter, sort, limit, skip }) =>
    GET(
      endpointsCenters.LOAD(
        centerType,
        franchiseExit,
        filter,
        sort,
        limit,
        skip,
      ),
    ),
  getById: async (id) => GET(endpointsCenters.BY_ID(id)),
  create: async (body) => POST(endpointsCenters.CREATE, body),
  update: async ({ id, body }) => PATCH(endpointsCenters.BY_ID(id), body),
  remove: async (id) => DELETE(endpointsCenters.BY_ID(id)),

  getProvinces: async () => GET(endpointsCenters.PROVINCES),

  comercialData: {
    getAll: async ({ id, filter, sort, limit, skip }) =>
      GET(endpointsCenters.COMERCIAL.LOAD(id, filter, sort, limit, skip)),
    getById: async ({ id, rowId }) =>
      GET(endpointsCenters.COMERCIAL.BY_ID(id, rowId)),
    create: async ({ id, body }) =>
      POST(endpointsCenters.COMERCIAL.CREATE(id), body),
    update: async ({ id, rowId, body }) =>
      PATCH(endpointsCenters.COMERCIAL.BY_ID(id, rowId), body),
    remove: async ({ id, rowId }) =>
      DELETE(endpointsCenters.COMERCIAL.BY_ID(id, rowId)),
    getComercialDatas: async (id) => GET(endpointsCenters.COMERCIAL.LOAD(id)),
  },

  workers: {
    getAll: async ({ id, filter, sort, limit, skip }) =>
      GET(endpointsCenters.WORKERS.LOAD(id, filter, sort, limit, skip)),
  },

  technics: {
    getById: async (id) => GET(endpointsCenters.TECHNICS.BY_ID(id)),
    update: async ({ id, body }) =>
      PATCH(endpointsCenters.TECHNICS.UPDATE(id), body),
    aspirators: {
      create: async ({ id, body }) =>
        POST(endpointsCenters.TECHNICS.ASPIRATORS.CREATE(id), body),
      remove: async ({ id, rowId }) =>
        DELETE(endpointsCenters.TECHNICS.ASPIRATORS.BY_ID(id, rowId)),
    },
    tracks: {
      create: async ({ id, body }) =>
        POST(endpointsCenters.TECHNICS.TRACKS.CREATE(id), body),
      remove: async ({ id, rowId }) =>
        DELETE(endpointsCenters.TECHNICS.TRACKS.BY_ID(id, rowId)),
    },
    others: {
      create: async ({ id, body }) =>
        POST(endpointsCenters.TECHNICS.OTHERS.CREATE(id), body),
      remove: async ({ id, rowId }) =>
        DELETE(endpointsCenters.TECHNICS.OTHERS.BY_ID(id, rowId)),
    },
  },

  contracts: {
    // getAll: async (id) => GET(endpointsCenters.CONTRACTS.LOAD(id)),
    getById: async (id) => GET(endpointsCenters.CONTRACTS.LOAD(id)),
    // getById: async ({id, rowId}) => GET(endpointsCenters.CONTRACTS.BY_ID(id, rowId)),
    update: async ({ id, body }) =>
      PATCH(endpointsCenters.CONTRACTS.LOAD(id), body),

    file: {
      create: async ({ id, body }) =>
        POST_FILE(endpointsCenters.CONTRACTS.UPLOAD(id), body),
      update: async ({ id, rowId, body }) =>
        PATCH(endpointsCenters.CONTRACTS.FILE_BY_ID({ id, rowId }), body),
      getById: async ({ id, rowId }) =>
        GET_FILE(endpointsCenters.CONTRACTS.FILE_BY_ID({ id, rowId })),
      remove: async ({ id, rowId }) =>
        DELETE(endpointsCenters.CONTRACTS.FILE_BY_ID({ id, rowId })),
    },

    uploadFile: async ({ id, file }) =>
      POST_FILE(endpointsCenters.CONTRACTS.UPLOAD(id), file),

    // renewalDate: {
    //     create: async ({id, body}) => POST(endpointsCenters.CONTRACTS.RENEWAL_DATE(id), body),
    //     remove: async ({id, rowId}) => DELETE(endpointsCenters.CONTRACTS.RENEWAL_DATE(id, rowId)),
    // }
  },

  conventions: {
    getAll: async (id) => GET(endpointsCenters.CONVENTIONS.LOAD(id)),
    create: async ({ id, body }) =>
      POST(endpointsCenters.CONVENTIONS.LOAD(id), body),
    remove: async ({ id, rowId }) =>
      DELETE(endpointsCenters.CONVENTIONS.BY_ID(id, rowId)),
  },

  services: {
    getById: async (id) => GET(endpointsCenters.SERVICES.LOAD(id)),
    update: async ({ id, body }) =>
      PATCH(endpointsCenters.SERVICES.BY_ID(id), body),
  },

  maintenances: {
    getAll: async ({ id, filter, sort, limit, skip }) =>
      GET(endpointsCenters.MAINTENANCES.LOAD(id, filter, sort, limit, skip)),
    getById: async ({ id, rowId }) =>
      GET(endpointsCenters.MAINTENANCES.BY_ID(id, rowId)),
    create: async ({ id, body }) =>
      POST(endpointsCenters.MAINTENANCES.CREATE(id), body),
    update: async ({ id, rowId, body }) =>
      PATCH(endpointsCenters.MAINTENANCES.BY_ID(id, rowId), body),
    remove: async ({ id, rowId }) =>
      DELETE(endpointsCenters.MAINTENANCES.BY_ID(id, rowId)),
  },

  cashRegisters: {
    getAll: async ({ id, filter, sort, limit, skip }) =>
      GET(endpointsCenters.CASH_REGISTERS.LOAD(id, filter, sort, limit, skip)),
    getById: async ({ id, rowId }) =>
      GET(endpointsCenters.CASH_REGISTERS.BY_ID(id, rowId)),
    create: async ({ id, body }) =>
      POST(endpointsCenters.CASH_REGISTERS.CREATE(id), body),
    update: async ({ id, rowId, body }) =>
      PATCH(endpointsCenters.CASH_REGISTERS.BY_ID(id, rowId), body),
  },

  manuals: {
    getAll: async ({ id, filter, sort, limit, skip }) =>
      GET(endpointsCenters.MANUALS.LOAD(id, filter, sort, limit, skip)),
    file: {
      create: async ({ id, body }) =>
        POST(endpointsCenters.MANUALS.UPLOAD(id), body),
      update: async ({ id, rowId, body }) =>
        PATCH(endpointsCenters.MANUALS.FILE_BY_ID({ id, rowId }), body),
      getById: async ({ id, rowId }) =>
        GET_FILE(endpointsCenters.MANUALS.FILE_BY_ID({ id, rowId })),
      remove: async ({ id, rowId }) =>
        DELETE(endpointsCenters.MANUALS.FILE_BY_ID({ id, rowId })),
    },
  },
}

export default CenterService

export const uploadFile = createAsyncThunkMiddleware(
  endpointsCenters.CREATE,
  CenterService.uploadFile,
)
